<section class="cz-task-card-dialog-component {{ (task.isOverDue) ? 'overdue' : '' }}">
  <mat-dialog-title class="mat-dialog-title">
    <div class="row">
      <div class="col-xs-10">
        <h3 class="title">{{ getTypeString(task?.taskTypeLabel) | translate}}</h3>
      </div>
      <div class="col-xs-2 end-xs">
        <button mat-button mat-dialog-close class="mat-dialog-back-button">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

  </mat-dialog-title>

  <form [formGroup]="taskFormGroup">
    <mat-dialog-content>
      <div class="row middle-xs">
        <div class="col-xs-5">
          <div class="font-size-large no-margin name-links"><span [innerHTML]="'$common_employee' | translate"></span>:
            <div class="name-links employee-name">
              <p class="profile-name links">{{ task?.subject?.displayName }}</p>
              <p class="font-size-small truncate">{{task?.subject?.userName}}</p>
            </div>
          </div>
        </div>
        <div class="col-xs-3">
          <mat-checkbox class="form-field" *ngIf="canEdit" [disabled]="getAssignToUser()"
            [formControl]="visibleToForUserControl">
            <span [innerHTML]="'$show_to_user_check_label' | translate"></span>
          </mat-checkbox>
        </div>
        <div class="col-xs-4 end-xs">
          <p class="form-field">
            <!-- Only show the button for completed tasks linked to evaluation -->
            <button *ngIf="hasPdfButton && isLinkedToEval && isAdmin" (click)="goToEvaluation()" mat-stroked-button
              color="accent" class="btn-pdf" mat-dialog-close [innerHTML]="'$btn_view' | translate"></button>

            <!-- Only show the button for completed linked tasks -->
            <button *ngIf="hasPdfButton" (click)="openPdfDialog()" mat-stroked-button color="accent" class="btn-pdf"
              mat-dialog-close [innerHTML]="'$btn_pdf_report' | translate"></button>

            <!-- Don't show the button for completed unlinked tasks, or on completed survey tasks. -->
            <!-- Only show the button to adminstrators, the person it is assigned to, or the person who created it. -->
            <button *ngIf="hasTaskButton" (click)="performTask()" mat-flat-button mat-dialog-close color="accent">
              {{ getTaskButtonCopy() }}
            </button>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-4" *ngIf="!task.isComplete">
          <mat-form-field class="form-field form-full-width-field">
            <mat-label [innerHTML]="'$common_assigned_to' | translate"></mat-label>
            <input formControlName="assignedToCtrl" [readonly]="getAssignToUser()" matInput type="text"
              [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="autocompleteDisplayUserOption"
              [readonly]="getAssignToUser()">
              <mat-option *ngFor="let option of assignedToFilteredOptions | async" [value]="option">
                <cz-user-select-item [user]="option"></cz-user-select-item>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <div class="col-xs-4" *ngIf="task.isComplete">
          <mat-form-field class="form-field form-full-width-field">
            <mat-label [innerHTML]="'$lng_cm_lab102' | translate"></mat-label>
            <input formControlName="completedByCtrl" matInput type="text">
          </mat-form-field>
        </div>

        <div *ngIf="!task.isComplete" class="col-xs-4">
          <mat-form-field class="form-full-width-field">
            <mat-label [innerHTML]="'$common_due_date' | translate"></mat-label>
            <input formControlName="dueDateCtrl" [readonly]="getAssignToUser()" matInput [matDatepicker]="dp"
              class="due-date">
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
            <mat-datepicker #dp [disabled]="!canEdit"></mat-datepicker>
          </mat-form-field>
        </div>
        <div *ngIf="task.isComplete" class="col-xs-4">
          <mat-form-field class="form-full-width-field">
            <mat-label [innerHTML]="'$common_change_completed_date' | translate"></mat-label>
            <input formControlName="completedDateCtrl" matInput readonly [matDatepicker]="dp" class="due-date">
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
            <mat-datepicker #dp [disabled]="isReadonly"></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-xs-4">
          <mat-form-field class="form-field form-full-width-field">
            <mat-label [innerHTML]="'$common_time_to_complete' | translate"></mat-label>
            <input formControlName="hoursCtrl" matInput [readonly]="getAssignToUser()">
            <mat-hint><span [innerHTML]="'$common_hint_example' | translate"></span>: 0.25</mat-hint>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <mat-form-field class="form-field form-full-width-field">
            <mat-label [innerHTML]="'$common_task_summary' | translate"></mat-label>
            <textarea formControlName="summaryCtrl" [readonly]="getAssignToUser()" matInput></textarea>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <mat-form-field class="form-field form-full-width-field">
            <mat-label [innerHTML]="'$common_task_details' | translate"></mat-label>
            <textarea formControlName="notesCtrl" matInput [readonly]="getAssignToUser()"></textarea>
          </mat-form-field>
        </div>
      </div>
    </mat-dialog-content>
    <mat-actions>
      <div class="row" *ngIf="!isReadonly && canEdit">
        <div class="col-xs-6">
          <p><button mat-button class="link" mat-dialog-close [innerHTML]="'$btn_cancel' | translate"></button></p>
        </div>
        <div class="col-xs-6 end-xs">
          <p><button (click)="updateTask()" mat-flat-button class="link" color="primary" mat-dialog-close
              [innerHTML]="'$btn_save' | translate"></button></p>
        </div>
      </div>
    </mat-actions>
  </form>
</section>